import { OrderProduct } from "ts/api/order";
import Fee from "ts/api/fee";

export const getUniqueOrderFees = (orderProducts: OrderProduct[]): Fee[] => {
  const feeById = orderProducts.reduce<Record<string, Fee>>(
    (acc, { fees = [] }) => {
      for (const fee of fees) {
        if (!acc[fee.id]) {
          acc[fee.id] = fee;
        }
      }
      return acc;
    },
    {}
  );

  return Object.values(feeById);
};
